import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { standardHttpOptions } from '../../shared/models';
import { LoadingService } from '../../shared/services/loading.service';
import { Observable, throwError } from 'rxjs';
import { KigSettings, KIG_SETTINGS } from '../../../settings/kig-settings';
import { SensorQueryParameterInfo } from '../../shared/models';
import { of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';


@Injectable()
export class MapReadingsService {
  private apiUrl: string;

  constructor(private http: HttpClient,
                private loadingService: LoadingService,
                @Inject(KIG_SETTINGS) private settings: KigSettings) {
    this.apiUrl = this.settings.apiUrl;
  }

  public getSensorReadingsForMap(parameters: SensorQueryParameterInfo): Observable<any> {
    this.loadingService.setMessage('Loading Sensor Readings ...');
    return this.http.post(`${ this.apiUrl }/sensorreading/readingsForGeoMap`, JSON.stringify(parameters), standardHttpOptions).pipe(
      catchError(error => {
        if (error.status === 404) {
          return of(null);
        }
        return throwError(error);
      }),
      finalize(() => this.loadingService.clearMessage())
    );
  }
}
